const BOOKING_WINDOW_KEYS = [
  'max_hours_before_booking',
  'min_hours_before_booking',
]

// An emptied NumberInput yields null; drop the key so the setting stays unset
// (unlimited) instead of being stored as null or 0. Other settings keys are
// left untouched.
export const stripEmptyBookingWindow = (values) => {
  if (!values.settings) return values
  const settings = { ...values.settings }
  BOOKING_WINDOW_KEYS.forEach((key) => {
    if (settings[key] === null || settings[key] === '') delete settings[key]
  })
  return { ...values, settings }
}
